'use client'

import * as React from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'

/** Zusätzliche Betonung am linken Rand für Pflicht-Controls (Input, SelectTrigger, …). */
export const fieldRequiredControlClass = 'border-l-[3px] border-l-primary pl-2.5'

/**
 * Form-Label mit sichtbarem Required field-Marker (*).
 * Zusätzlich `aria-required` auf dem zugehörigen Control setzen, wo möglich.
 */
export function FieldLabel({
    required,
    className,
    children,
    ...props
}: React.ComponentProps<typeof Label> & { required?: boolean }) {
    return (
        <Label className={cn(className)} {...props}>
            {children}
            {required ? (
                <span className='text-destructive ml-0.5 font-semibold' aria-hidden>
                    *
                </span>
            ) : null}
        </Label>
    )
}
